import logo from "./logo.svg";
import "./App.css";
import { Switch, Route, Redirect } from "react-router-dom";
import Layout from "./layout";

import "./assets/css/styles.css";

import Activities from "./page/Activities";
import Dashboard from "./page/Dashboard";
import ReportRecord from "./page/ReportRecord";
import Students from "./page/Students";
import Setting from "./page/Setting";
import PersonalStudentPage from "./page/PersonalStudent";
import TrainImageFromActivities from './page/TrainImageFromActivities'

export default function App() {
  return (
    <Switch>
      <Layout>
        <Route exact path="/" component={() => <Redirect to="/dashboard" />} />
        {/* <Route exact path="/" component={Dashboard} /> */}
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/activities" component={Activities} />
        <Route exact path="/activities/train-image-activities/:idActivities" component={TrainImageFromActivities} />
        <Route exact path="/report-record" component={ReportRecord} />
        <Route exact path="/students" component={Students} />
        <Route exact path="/students/personal" component={PersonalStudentPage} />
        <Route exact path="/setting" component={Setting} />
      </Layout>
    </Switch>
  );
}
